import React, { useState } from "react";

import DynamicTable from "../../../components/reusable/DynamicTable";
import PageHeader from "../../../components/reusable/management/PageHeader";
import StatsGrid from "../../../components/reusable/management/StatsGrid";
import ManagementToolbar from "../../../components/reusable/management/ManagementToolbar";
import ManagementDrawer from "../../../components/reusable/management/ManagementDrawer";

import { roleStats } from "./models/roles_permissions_model/RoleStatsConfig";
import { roleColumns, roleData } from "./models/roles_permissions_model/RoleTableData";

const CARolesPermissionsDashboard = () => {
    const [selectedRole, setSelectedRole] = useState(null);
    const [drawerOpen, setDrawerOpen] = useState(false);

    const actions = [
        {
            label: "View", title: "View Role",
            onClick: (role) => {
                setSelectedRole(role);
                setDrawerOpen(true);
            },
        },
    ];

    return (
        <>
            <PageHeader
                title="Roles & Permissions"
                subtitle="Manage employee roles and platform permissions."
                actions={[
                    {
                        label: "Create Role",
                        icon: "+",
                    },
                ]}
            />

            <StatsGrid cards={roleStats} />

            <ManagementToolbar
                searchPlaceholder="Search role..."
                filters={[
                    {
                        key: "status",
                        label: "Status",
                        options: [ "Active", "Inactive" ],
                    },
                ]}
            />

            <DynamicTable
                columns  = { roleColumns }
                data     = { roleData }
                onAction = { actions }
            />

            {
                selectedRole && (
                    <ManagementDrawer
                        isOpen={drawerOpen}
                        onClose={() => setDrawerOpen(false)}
                        title="Role Details"
                        sections={[
                            {
                                title: "General Information",
                                fields: [
                                    { label: "Role", value: selectedRole.name },
                                    { label: "Description", value: selectedRole.description },
                                    { label: "Employees", value: selectedRole.users },
                                    { label: "Status", value: selectedRole.status },
                                ],
                            },

                            {
                                title: "Permissions",
                                fields: [
                                    {
                                        label: "Permissions",
                                        value: selectedRole.permissions.join(", "),
                                    },
                                ],
                            },
                        ]}
                    />
                )
            }
        </>
    );
};

export default CARolesPermissionsDashboard;
